export default __webpack_public_path__ + "static/media/we-post.52f27d99.png";